import styled from 'styled-components'

export const MainContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 72px auto 127px;
  justify-items: stretch;
  align-items: stretch;
  @media only screen and (max-width: 640px) {
    grid-template-rows: 72px auto 260px;
  }
`

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0 48px;
  background: #fff;
  box-shadow: 0px 1px 2px rgba(53, 53, 53, 0.12);
  display: flex;
  align-items: center;
  justify-content: space-between;

  & a {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .tlie-header-contact {
    font-size: 12px;
    line-height: 18px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-around;
    text-align: right;
    margin-left: 8px;
  }

  .tlie-header-contact a {
    font-size: 14px;
    line-height: 21px;
    font-weight: 700;
    display: flex;
    align-items: center;
    color: #3D6666;
    gap: 5px;
    text-decoration: none;
  }

  @media only screen and (max-width: 640px) {
    max-width: 100vw;
    padding: 0 24px;
  }
`

export const BodyContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #F9F5F2;
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    width: 100%;
    height: 100%;
    max-width: 1100px;
    padding: 64px 0 20px;
  }
`

export const FooterContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;

  & > div {
    width: 630px;
    height: 100%;
    padding: 30px 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  @media only screen and (max-width: 640px) {
    max-width: 100vw;
    & > div {
      width: 200px;
      flex-direction: column;
      gap: 10px;
    }
  }
`

export const FooterColumn = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  & div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7B7C82;
    font-size: 10px;
    line-height: 16px;
    font-weight: 700;
  }

  & a {
    text-decoration: none;
    color: #7B7C82;
    border-bottom: 1px solid #7B7C82;
  }

  & a + a {
    margin-left: 24px;
  }
  
  & strong {
    font-size: 14px;
    font-weight: 900;
    line-height: 21px;    
    color: #353744;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  & strong a {
    border: none;
    color: #353744;
    display: flex;
    align-items: center;
    gap: 5px;
  }

  & hr {
    border: 1px solid #C8C8C8;
    height: 1px;
    width: 90%;
    background-color: #C8C8C8;
  }

  @media only screen and (max-width: 640px) {
    gap: 10px;
  }
`